export const projectSituationRoomRoutes = [
  {
    path: 'situationroom',
    name: 'SituationRoom',
    component: () => import('@/views/situationRoom/index.vue'),
    meta: {
      release: false,
      zhTw: '能源儀表板'
    }
  }
]
